import type { OfficeDataDto } from '../dto';
import type { OfficeData } from '../models';

export const mapOfficeDataDtoToModel = (dto: OfficeDataDto): OfficeData => ({
  ...dto,
});
